/* =============================================================================
   ATTENTION — fichier for.me, pas un fichier natif Pitch.
   Le fichier Pitch d'origine a ete renomme en : pitch-header.js
   Si tu mets un jour Pitch a jour, la mise a jour reinstallera son propre
   header.js et ECRASERA ce fichier. Sauvegarde-le avant toute mise a jour.
   ============================================================================= */

/* ==========================================================================
   site-chrome.js
   ========================================================================== */

(function () {
  /* ---- 1) Filtre SVG liquid glass ---- */
  function injectFilter() {
    if (document.getElementById('liquid-glass-svg')) return;
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('id', 'liquid-glass-svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden;pointer-events:none';
    svg.innerHTML =
      '<filter id="liquid-glass" x="-40%" y="-40%" width="180%" height="180%" color-interpolation-filters="sRGB">' +
        '<feTurbulence type="fractalNoise" baseFrequency="0.009 0.018" numOctaves="3" seed="7" result="noise"/>' +
        '<feGaussianBlur in="noise" stdDeviation="1" result="soft"/>' +
        '<feDisplacementMap in="SourceGraphic" in2="soft" scale="90" xChannelSelector="R" yChannelSelector="G"/>' +
      '</filter>' +
      '<filter id="liquid-glass-soft" x="-20%" y="-20%" width="140%" height="140%" color-interpolation-filters="sRGB">' +
        '<feTurbulence type="fractalNoise" baseFrequency="0.006 0.012" numOctaves="2" seed="7" result="noise"/>' +
        '<feGaussianBlur in="noise" stdDeviation="1.4" result="soft"/>' +
        '<feDisplacementMap in="SourceGraphic" in2="soft" scale="22" xChannelSelector="R" yChannelSelector="G"/>' +
      '</filter>';
    (document.body || document.documentElement).appendChild(svg);
  }

  /* ---- 2) Panneau de verre du mega menu ---- */
  function setupMegaGlass(header) {
    if (!header || header.__megaGlass) return;

    var panel = document.createElement('div');
    panel.id = 'custom-mega-glass';
    panel.setAttribute('aria-hidden', 'true');
    header.insertBefore(panel, header.firstChild);
    header.__megaGlass = panel;

    function visibleInner() {
      var subs = header.querySelectorAll('.menu-list__submenu');
      for (var i = 0; i < subs.length; i++) {
        var sm = subs[i];
        if (getComputedStyle(sm).visibility === 'hidden') continue;
        var inner = sm.querySelector('.menu-list__submenu-inner') || sm;
        var r = inner.getBoundingClientRect();
        if (r.height > 2 && r.width > 2) return inner;
      }
      return null;
    }

    function place(inner) {
      var r = inner.getBoundingClientRect();
      panel.style.left = r.left + 'px';
      panel.style.top = r.top + 'px';
      panel.style.width = r.width + 'px';
      panel.style.height = r.height + 'px';
      panel.setAttribute('data-open', '');
    }

    var raf = 0;
    function tick() {
      var inner = visibleInner();
      if (inner) {
        place(inner);
        header.setAttribute('data-mega-open', '');
        raf = requestAnimationFrame(tick);
      } else {
        panel.removeAttribute('data-open');
        header.removeAttribute('data-mega-open');
        raf = 0;
      }
    }
    function kick() { if (!raf) raf = requestAnimationFrame(tick); }

    ['pointerover', 'pointerout', 'pointermove', 'focusin', 'focusout'].forEach(function (ev) {
      header.addEventListener(ev, kick, true);
    });
    new MutationObserver(kick).observe(header, {
      subtree: true, attributes: true,
      attributeFilter: ['data-active', 'aria-expanded', 'style', 'class']
    });
    window.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('resize', kick);
  }

  /* ---- 3) Forcer le HAMBURGER des qu'un item du menu deborde ---- */
  function setupHamburgerOverflow(header) {
    var ol = header.querySelector('overflow-list');
    if (!ol) return;
    if (header.__hamburgerFix) return;
    header.__hamburgerFix = true;

    function apply() {
      var n = 0, kids = ol.children;
      for (var i = 0; i < kids.length; i++) {
        var el = kids[i];
        if (el.nodeType === 1 && el.tagName !== 'TEMPLATE' && el.tagName !== 'SCRIPT') n++;
      }
      if (n > 0 && ol.getAttribute('minimum-items') !== String(n)) {
        ol.setAttribute('minimum-items', String(n));
      }
    }
    apply();
    new MutationObserver(apply).observe(ol, { childList: true });
  }

  /* ---- 4) Barre d'annonce en MARQUEE infini ---- */
  var MARQUEE_SPEED = 40;
  var MARQUEE_SEP = '★';

  function setupAnnouncementMarquee() {
    document.querySelectorAll('.announcement-bar__slider').forEach(function (slider) {
      if (slider.__marquee) return;
      var slidesWrap = slider.querySelector('.announcement-bar__slides');
      if (!slidesWrap) return;
      var slides = slidesWrap.querySelectorAll('.announcement-bar__slide');
      if (!slides.length) return;

      var msgs = [];
      slides.forEach(function (s) { var h = s.innerHTML.trim(); if (h) msgs.push(h); });
      if (!msgs.length) return;

      slider.__marquee = true;

      var marquee = document.createElement('div');
      marquee.className = 'custom-marquee';
      marquee.setAttribute('aria-hidden', 'true');
      var track = document.createElement('div');
      track.className = 'custom-marquee__track';
      marquee.appendChild(track);
      slider.appendChild(marquee);

      function makeSeg() {
        var seg = document.createElement('span');
        seg.className = 'cm-seg';
        for (var i = 0; i < msgs.length; i++) {
          var item = document.createElement('span');
          item.className = 'cm-item';
          item.innerHTML = msgs[i];
          seg.appendChild(item);
          var sep = document.createElement('span');
          sep.className = 'cm-sep';
          sep.textContent = MARQUEE_SEP;
          seg.appendChild(sep);
        }
        return seg;
      }

      function build() {
        track.innerHTML = '';
        var probe = makeSeg();
        track.appendChild(probe);
        var segW = probe.getBoundingClientRect().width || 1;
        var cw = marquee.getBoundingClientRect().width || window.innerWidth;

        var copies = Math.max(1, Math.ceil(cw / segW) + 1);
        function makeList() {
          var list = document.createElement('span');
          list.className = 'cm-list';
          for (var i = 0; i < copies; i++) list.appendChild(makeSeg());
          return list;
        }

        track.innerHTML = '';
        var list1 = makeList();
        track.appendChild(list1);
        track.appendChild(makeList());

        var listW = list1.getBoundingClientRect().width || segW;
        var dur = Math.max(6, listW / MARQUEE_SPEED);
        track.style.setProperty('--cm-dur', dur.toFixed(1) + 's');
      }

      build();

      var t;
      window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(build, 200); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(build);
    });
  }

  /* ---- 5) Banniere d'accueil en PLEIN ECRAN ---- */
  /* Hauteur de la bannière sur PORTABLE = largeur × ce facteur.
     On utilise un ratio standard : 3/4 (portrait) -> facteur 4/3 ≈ 1.333,
     soit un cran au-dessus du 4/5 (= 1.25). Autres ratios courants :
       4/5  -> 5/4  = 1.25   (le plus resserré)
       3/4  -> 4/3  = 1.333  (actuel)
       2/3  -> 3/2  = 1.5    (plus haut)
       9/16 -> 16/9 = 1.777  (story plein portrait) */
  var HERO_MOBILE_RATIO = 4 / 3;
  function BANNER_BOTTOM_GAP() {
    // 10px sur mobile, 15px sinon (aligné sur la marge CSS des bannières)
    return (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) ? 10 : 15;
  }
  var bannerOffset = null;
  function headerAtRest() {
    var h = document.querySelector('#header-component') || document.querySelector('header-component');
    return !h || h.getAttribute('data-sticky-state') !== 'active';
  }
  function fitBanner() {
    // ACCUEIL UNIQUEMENT : ne touche aucune bannière des autres pages.
    var main = document.getElementById('MainContent');
    if (!main || (main.getAttribute('data-template') || '').indexOf('index') !== 0) return;
    // querySelector = LA PREMIÈRE .hero-wrapper seulement (pas les autres bannières).
    var el = document.querySelector('.shopify-section.hero-wrapper') ||
             document.querySelector('.hero-wrapper');
    if (!el) return;
    var hero = el.querySelector('.hero');
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;

    /* ---- PORTABLE : la 1re bannière prend un ratio 3/4 (portrait) ----
       hauteur = largeur × 4/3, valeur pilotée par HERO_MOBILE_RATIO ci-dessus. La largeur est déjà celle affichée (les 10px de
       marge latérale sont EN DEHORS de la section) -> le ratio les respecte
       automatiquement. On neutralise le min-height:100svh interne du .hero
       (sinon il forcerait la bannière en plein écran malgré le ratio). */
    if (isMobile) {
      el.style.removeProperty('aspect-ratio');
      var w = el.getBoundingClientRect().width || el.clientWidth || 0;
      if (w > 0) el.style.setProperty('height', Math.round(w * HERO_MOBILE_RATIO) + 'px', 'important');
      if (hero) {
        hero.style.setProperty('min-height', '0', 'important');
        hero.style.setProperty('height', '100%', 'important');
      }
      return;
    }

    /* ---- DESKTOP / TABLETTE : PLEIN ÉCRAN ----
       100% de l'écran en déduisant l'announcement bar + le header + les 15px
       de marge (haut via 'top', bas via BANNER_BOTTOM_GAP). Inchangé. */
    if (hero) {                       // on retire les overrides mobile si on repasse en large
      hero.style.removeProperty('min-height');
      hero.style.removeProperty('height');
    }
    var y = window.scrollY || window.pageYOffset || 0;
    if (bannerOffset === null || (y < 4 && headerAtRest())) {
      var top = el.getBoundingClientRect().top + y;
      var measured = Math.max(0, Math.round(top)) + BANNER_BOTTOM_GAP();
      if (bannerOffset === null || measured >= bannerOffset - 2) bannerOffset = measured;
    }
    el.style.setProperty('height', 'calc(100vh - ' + bannerOffset + 'px)', 'important');
    el.style.setProperty('height', 'calc(100dvh - ' + bannerOffset + 'px)', 'important');
  }

  function scan() {
    document.querySelectorAll('#header-component, header-component').forEach(function (h) {
      setupMegaGlass(h);
      setupHamburgerOverflow(h);
    });
    setupAnnouncementMarquee();
    fitBanner();
  }

  function init() {
    injectFilter();
    scan();
    window.addEventListener('resize', fitBanner);
    window.addEventListener('load', fitBanner);
    var bTick = false;
    window.addEventListener('scroll', function () {
      if (bTick) return;
      bTick = true;
      requestAnimationFrame(function () { bTick = false; if ((window.scrollY || window.pageYOffset || 0) < 4) fitBanner(); });
    }, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitBanner);
    setTimeout(fitBanner, 300);
    setTimeout(fitBanner, 1000);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var k = 0; k < added.length; k++) {
          var n = added[k];
          if (n.nodeType !== 1) continue;
          var isHeader = n.id === 'header-component' || (n.matches && (n.matches('header-component') || n.matches('overflow-list') || n.matches('.announcement-bar__slider')));
          var hasHeader = n.querySelector && (n.querySelector('#header-component') || n.querySelector('header-component') || n.querySelector('overflow-list') || n.querySelector('.announcement-bar__slider'));
          if (isHeader || hasHeader) scan();
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* ==========================================================================
   Bouton "LE CLUB" injecté dans le header
   - Assez de place  -> INLINE, juste à gauche du search (classe .club--inline)
   - Plus assez / mobile -> ABSOLU sous l'account (classe .club--floating)
   Le placement est re-évalué au chargement, au resize et quand le menu change.
   ========================================================================== */
(function () {
  /* 989 : la tablette passe au drawer, il n'y a donc plus de menu inline à
     côté duquel poser le club — il prend le placement flottant du
     téléphone. */
  var MOBILE_BP = 989;  // <= : PORTABLE ET TABLETTE -> flottant sous les icônes ; au-dessus -> inline
  var MIN_GAP   = 24;   // px mini entre le menu et le club (sinon -> flottant)
  var ICON_GAP  = 12;   // px entre le club et l'icône (search/account) à sa droite

  function insertClub() {
    var header = document.querySelector('#header-component');
    if (!header) return;
    // On l'insère DANS la pilule (.header__row--top, en position:relative) et pas
    // dans la colonne d'icônes : celle-ci est en display:contents (grille) -> un
    // enfant y serait coincé dans une case ~40px (= le rond). En absolu dans la
    // pilule, le club n'est plus une case de grille -> pilule normale.
    var row = header.querySelector('.header__row--top') || header;

    var club = document.querySelector('.club-floating-btn');
    if (!club) {
      club = document.createElement('a');
      club.className = 'club-floating-btn';
      club.href = '/pages/le-club';                 // <-- METS TON LIEN ICI
      club.setAttribute('aria-label', 'Le Club');
      club.innerHTML =
        '<span class="club-star"><svg viewBox="0 0 24 24">' +
        '<path d="M12 2l2.9 6.9 7.1.6-5.4 4.7 1.6 7-6.2-3.7-6.2 3.7 1.6-7L2 9.5l7.1-.6z"/>' +
        '</svg></span>LE CLUB';
    }
    if (club.parentElement !== row) row.appendChild(club);
    placeClub();
  }

  // Le "menu" inline (colonne centrale) dont on mesure le bord droit
  function menuEl(header) {
    return header.querySelector('.header__inline-menu')
        || header.querySelector('.menu-list')
        || header.querySelector('overflow-list')
        || header.querySelector('.header__column--center');
  }
  function menuVisible(menu) {
    if (!menu) return false;
    var cs = getComputedStyle(menu);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    var r = menu.getBoundingClientRect();
    return r.width > 4 && r.height > 4;
  }
  // L'icône de référence = 1re icône de droite (search desktop / account petit écran)
  function refIcon(header) {
    var right = header.querySelector('.header__column--right');
    return right ? right.firstElementChild : null;
  }

  function toInline(club, rightPx) {
    club.classList.add('club--inline');
    club.classList.remove('club--floating');
    club.style.setProperty('right', rightPx + 'px', 'important');   // JS place à gauche de l'icône
  }
  function toFloating(club) {
    club.classList.remove('club--inline');
    club.classList.add('club--floating');
    club.style.removeProperty('right');   // laisse le CSS (var --club-float-right) gérer
  }

  function placeClub() {
    var club = document.querySelector('.club-floating-btn');
    var header = document.querySelector('#header-component');
    if (!club || !header) return;

    // PORTABLE : flottant sous les icônes
    if (window.innerWidth <= MOBILE_BP) { toFloating(club); return; }

    var row = header.querySelector('.header__row--top');
    var icon = refIcon(header);
    if (!row || !icon) { toFloating(club); return; }   // fallback

    // On calcule le "right" pour caler le bord droit du club juste à gauche de l'icône.
    var rowRect = row.getBoundingClientRect();
    var iconRect = icon.getBoundingClientRect();
    var rightPx = Math.round(rowRect.right - iconRect.left + ICON_GAP);
    toInline(club, rightPx);

    // Si le menu complet est visible ET que le club chevaucherait le menu -> flottant.
    var menu = menuEl(header);
    if (menuVisible(menu)) {
      var clubLeft = iconRect.left - ICON_GAP - club.offsetWidth;
      if (clubLeft - menu.getBoundingClientRect().right < MIN_GAP) toFloating(club);
    }
  }

  // Rebascule quand le hamburger s'active/se désactive (changement de classe/style
  // sur le header, pas forcément un ajout d'élément).
  function observeHeader() {
    var header = document.querySelector('#header-component');
    if (!header || header.__clubObserved) return;
    header.__clubObserved = true;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(placeClub, 100);
    }).observe(header, {
      attributes: true, subtree: true, childList: true,
      attributeFilter: ['class', 'style', 'hidden', 'minimum-items', 'aria-expanded']
    });
  }

  insertClub();
  observeHeader();
  document.addEventListener('DOMContentLoaded', insertClub);
  document.addEventListener('shopify:section:load', insertClub);
  window.addEventListener('load', placeClub);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeClub);
  var rt = null;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(placeClub, 120); });
  var hg = document.getElementById('header-group');
  if (hg) new MutationObserver(function () { insertClub(); placeClub(); }).observe(hg, { childList: true, subtree: true });
})();

/* ==========================================================================
   Pages produit : header en état "scrollé" dès l'arrivée — ORDI ET PORTABLE
   --------------------------------------------------------------------------
   Ce bloc force data-sticky-state="active" sur le header dès l'ouverture
   d'une fiche produit, et le repose en boucle via un MutationObserver dès
   que le thème essaie de l'enlever.

   L'ÉTAT « ACTIF » EST CE QUI DONNE LA PILULE DE VERRE (header.css §2) :
   fond gris translucide, backdrop-filter, bordure claire, reflets, et la
   marge du haut qui passe de 30 à 15px. Sans lui, le header reste au repos :
   transparent, sans pilule.

   SUR ORDI, la fiche produit n'a rien derrière le header, le contenu commence
   sous lui. Au repos il serait blanc sur blanc, donc invisible : le forçage
   est la seule façon de le voir.

   SUR PORTABLE, la galerie passe maintenant DERRIÈRE le header (bord à bord,
   depuis le haut de page). On avait donc retiré le forçage, pour laisser la
   photo nue sous un header transparent. Choix revu : la pilule de verre par
   -dessus l'image, c'est justement l'effet voulu. Le forçage vaut donc
   partout, et la limite 750px n'a plus lieu d'être.

   LA COULEUR SUIT TOUTE SEULE : --header-white-product vaut 0, donc texte,
   icônes et logo sont en #212121 — lisibles sur le verre, au repos comme au
   défilement. Rien à changer dans header.css.

   POUR REVENIR EN ARRIÈRE : FORCER = false rend le header au repos partout,
   y compris sur ordi.
   ========================================================================== */
(function () {
  var FORCER = true;   /* false = header au repos partout, y compris sur ordi */
  if (!FORCER) return;

  var main = document.getElementById('MainContent');
  if (!main) return;
  var tpl = main.getAttribute('data-template') || '';
  if (tpl.indexOf('product') !== 0) return;

  var header = document.querySelector('#header-component');
  if (!header) return;

  function force() {
    if (header.getAttribute('data-sticky-state') !== 'active') {
      header.setAttribute('data-sticky-state', 'active');
    }
  }

  force();
  new MutationObserver(force).observe(header, {
    attributes: true,
    attributeFilter: ['data-sticky-state'],
  });
})();


/* ==========================================================================
   ÉTOILE "NOUVEAU" dans le MÉGA MENU (liste MANUELLE)
   --------------------------------------------------------------------------
   Tu écris toi-même quels liens doivent avoir la petite étoile clignotante :
   il suffit de mettre le NOM du lien (tel qu'affiché) dans NEW_LINKS ci-dessous.
   (Tu peux aussi mettre un bout d'URL/handle, ex : 'lip-liner-crayon-a-levres'.)
   L'étoile s'ajoute à GAUCHE de CHAQUE lien texte qui correspond (pas les cards).
   Style dans header.css : .mega-new-star
   ========================================================================== */
(function () {
  'use strict';

  /* >>>>>>>>>>>>>>>>  ÉCRIS ICI LES LIENS "NOUVEAU"  <<<<<<<<<<<<<<<<<<<<<<<<
     (le nom du lien tel qu'affiché ; insensible à la casse/espaces) */
  var NEW_LINKS = [
    'Duo Bronzer',
    'Lip Liner',
    'Coffret Lip Liners',
    'Lip Pocket',
  ];
  /* <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

  var STAR = '★';   /* étoile 5 branches. Autres : ☆ ✦ ✧ ✷ ❋ ✴ */

  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  var wanted = NEW_LINKS.map(norm).filter(Boolean);

  // texte du lien SANS l'étoile déjà injectée
  function linkText(a) {
    var t = '';
    [].forEach.call(a.childNodes, function (n) {
      if (n.nodeType === 3) t += n.textContent;
      else if (n.nodeType === 1 && !n.classList.contains('mega-new-star')) t += n.textContent;
    });
    return norm(t);
  }
  function matches(a) {
    var txt = linkText(a);
    var href = norm(a.getAttribute('href') || '');
    return wanted.some(function (w) {
      return txt === w || (w.indexOf(' ') === -1 && href.indexOf(w) !== -1);
    });
  }
  function addStar(a) {
    // on se base UNIQUEMENT sur la présence réelle de l'étoile (pas un flag) :
    // si le méga menu se reconstruit et vide le lien, l'observer la re-pose.
    if (a.querySelector('.mega-new-star')) return;
    var s = document.createElement('span');
    s.className = 'mega-new-star';
    s.setAttribute('aria-hidden', 'true');
    s.textContent = STAR;
    a.insertBefore(s, a.firstChild);   // à GAUCHE du lien
  }
  function scan() {
    var links = document.querySelectorAll(
      '#header-component .menu-list__submenu a, #header-component .mega-menu a'
    );
    [].forEach.call(links, function (a) {
      if (a.closest('.cmc-card')) return;   // on ignore les CARDS (que les liens texte)
      if (matches(a)) addStar(a);
    });
  }
  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    scan();
    setTimeout(scan, 800);
    var header = document.getElementById('header-component');
    if (header) {
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 120); })
        .observe(header, { childList: true, subtree: true });
    }
  });
})();

/* ==========================================================================
   ACCUEIL : header en "état scrollé" DÈS le début du scroll (pas de délai)
   --------------------------------------------------------------------------
   Le thème n'active data-sticky-state='active' qu'après un certain seuil de
   scroll -> le verre du header (et le passage logo/texte en foncé) arrivait en
   retard. Ici on force 'active' dès qu'on a scrollé (> SCROLL_TRIGGER px) et on
   revient à l'état repos tout en haut de la page.
   (Uniquement l'accueil. Les pages produit avaient leur propre forçage, il
   est désormais désactivé — voir le bloc précédent.)
   ========================================================================== */
(function () {
  var main = document.getElementById('MainContent');
  if (!main || (main.getAttribute('data-template') || '').indexOf('index') !== 0) return;
  var header = document.querySelector('#header-component');
  if (!header) return;

  var SCROLL_TRIGGER = 8;   // px de scroll avant d'activer l'état "scrollé" (baisse = encore + tôt)

  // valeur "repos" d'origine du thème (souvent 'idle' ou absente). Si la page
  // est déjà scrollée au chargement, on ne prend pas 'active' comme repos.
  var idleVal = header.getAttribute('data-sticky-state');
  if (idleVal === 'active') idleVal = null;
  var self = false;

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }
  function desired() {
    var y = window.scrollY || window.pageYOffset || 0;
    return y > SCROLL_TRIGGER ? 'active' : idleVal;
  }
  function enforce() {
    // MOBILE UNIQUEMENT : sur ordi/tablette on ne touche à rien, la gestion
    // native du thème reprend la main (sinon le header partait en blanc).
    if (!isMobile()) return;
    var d = desired(), cur = header.getAttribute('data-sticky-state');
    if (cur === d) return;
    self = true;
    if (d === null) header.removeAttribute('data-sticky-state');
    else header.setAttribute('data-sticky-state', d);
    self = false;
  }
  window.addEventListener('scroll', enforce, { passive: true });
  window.addEventListener('resize', enforce);
  // si le thème repose sa propre valeur pendant qu'on veut 'active', on ré-applique
  new MutationObserver(function () { if (!self) enforce(); })
    .observe(header, { attributes: true, attributeFilter: ['data-sticky-state'] });
  enforce();
})();
/* ==========================================================================
   « LE CLUB » OUVRE LE WIDGET LOYOLY
   --------------------------------------------------------------------------
   Loyoly injecte son propre bouton flottant, #loyoly-widget-launcher, en bas
   à droite. On ne le supprime PAS : c'est lui qui porte toute la logique
   d'ouverture du widget (et son code est à eux, il changera sans nous
   prévenir). On le rend invisible et inerte en CSS (header.css), et le
   bouton « LE CLUB » du header lui transmet simplement le clic.

   POURQUOI RELAYER LE CLIC PLUTÔT QUE D'APPELER LEUR API
   Il n'y a pas d'API publique stable ici. `lanceur.click()` emprunte le même
   chemin qu'un vrai clic de visiteur : tant que leur bouton existe, ça marche,
   quelle que soit la version de leur script.

   LE LIEN RESTE UN LIEN
   Si le lanceur est absent — script bloqué, widget désactivé, page chargée
   avant leur injection — on ne fait rien : le <a> suit son href vers
   /pages/le-club. Aucun clic perdu, jamais de bouton mort.

   POURQUOI UNE DÉLÉGATION SUR document
   Le bouton « LE CLUB » est recréé et redéplacé par insertClub()/placeClub()
   au chargement, au resize et aux changements de menu. Un écouteur posé
   dessus serait à recâbler à chaque fois ; sur document, il survit à tout.
   ========================================================================== */
(function () {
  'use strict';

  var ID_LANCEUR = 'loyoly-widget-launcher';

  function lanceur() {
    return document.getElementById(ID_LANCEUR);
  }

  /* ATTENTE DU LANCEUR AVANT DE RENONCER
     -------------------------------------------------------------------------
     Première version : « si le lanceur n'est pas là, on laisse le lien
     naviguer ». Sur portable, le script de Loyoly s'installe plus tard
     qu'ailleurs — connexion plus lente, scripts tiers différés — et au moment
     du tap il n'existe pas encore. Le lien partait donc vers /pages/le-club
     avant que le widget n'ait eu sa chance : d'où l'escale sur une page
     intermédiaire que l'ordinateur, lui, n'avait jamais.

     On empêche donc TOUJOURS la navigation d'abord, puis on guette le lanceur
     pendant 2,5 s. S'il arrive, on lui passe le clic. S'il n'arrive jamais —
     script bloqué, widget désactivé — on part sur le href : le bouton n'est
     jamais mort, il est seulement patient. */
  var ATTENTE_MS = 100;
  var ESSAIS = 25;               /* 25 × 100 ms = 2,5 s */

  document.addEventListener('click', function (e) {
    var club = e.target && e.target.closest ? e.target.closest('.club-floating-btn') : null;
    if (!club) return;

    e.preventDefault();

    var l = lanceur();
    if (l) { l.click(); return; }

    (function guetter(restant) {
      var trouve = lanceur();
      if (trouve) { trouve.click(); return; }
      if (restant <= 0) {
        var href = club.getAttribute('href');
        if (href) window.location.href = href;   /* dernier recours */
        return;
      }
      window.setTimeout(function () { guetter(restant - 1); }, ATTENTE_MS);
    })(ESSAIS);
  });

  /* Leur bouton est invisible mais toujours dans le document : sans ça, il
     resterait atteignable au clavier et annoncé par les lecteurs d'écran,
     alors qu'il ne se voit plus. Le CSS ne sait pas retirer du parcours de
     tabulation sans `visibility`/`display`, qu'on évite ici pour ne pas
     risquer d'emporter le panneau du widget avec. */
  function neutraliser() {
    var l = lanceur();
    if (!l || l.__fmNeutralise) return false;
    l.__fmNeutralise = true;
    l.setAttribute('tabindex', '-1');
    l.setAttribute('aria-hidden', 'true');
    return true;
  }

  /* Leur script est asynchrone : on guette son bouton 10 s au plus, puis on
     laisse tomber. Rien de vital n'en dépend — le masquage, lui, est en CSS
     et s'applique dès que l'élément apparaît. */
  (function guetter(restant) {
    if (neutraliser() || restant <= 0) return;
    window.setTimeout(function () { guetter(restant - 1); }, 200);
  })(50);
})();